// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* LatestSession.css */

.overlay {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    height: 100%;
    width: 100%;
    opacity: 0;
    transform: translateY(-100%); /* Start from above the container */
    transition: opacity 0.5s ease, transform 0.5s ease; /* Smooth transition for both opacity and transform */
    background-color: rgba(0, 0, 0, 0.6);
    display: flex;
    justify-content: center;
    align-items: center;
}

.h-80:hover .overlay {
    opacity: 1;
    transform: translateY(0); /* Slide into place on hover */
}

.h-80:hover .txts {
    visibility: hidden;
}

.overlay-text {
    color: white;
    font-size: 20px;
    text-align: center;
}
`, "",{"version":3,"sources":["webpack://./src/Pages/Homepage/LatestSession.css"],"names":[],"mappings":"AAAA,sBAAsB;;AAEtB;IACI,kBAAkB;IAClB,MAAM;IACN,SAAS;IACT,OAAO;IACP,QAAQ;IACR,YAAY;IACZ,WAAW;IACX,UAAU;IACV,4BAA4B,EAAE,mCAAmC;IACjE,kDAAkD,EAAE,qDAAqD;IACzG,oCAAoC;IACpC,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,UAAU;IACV,wBAAwB,EAAE,8BAA8B;AAC5D;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,eAAe;IACf,kBAAkB;AACtB","sourcesContent":["/* LatestSession.css */\n\n.overlay {\n    position: absolute;\n    top: 0;\n    bottom: 0;\n    left: 0;\n    right: 0;\n    height: 100%;\n    width: 100%;\n    opacity: 0;\n    transform: translateY(-100%); /* Start from above the container */\n    transition: opacity 0.5s ease, transform 0.5s ease; /* Smooth transition for both opacity and transform */\n    background-color: rgba(0, 0, 0, 0.6);\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n\n.h-80:hover .overlay {\n    opacity: 1;\n    transform: translateY(0); /* Slide into place on hover */\n}\n\n.h-80:hover .txts {\n    visibility: hidden;\n}\n\n.overlay-text {\n    color: white;\n    font-size: 20px;\n    text-align: center;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
